import { NgModule } from '@angular/core';
import { PSplitterComponent } from './p-splitter.component';
import { PSplitterAreaComponent } from './p-splitter-area.component';

@NgModule({
    imports: [PSplitterComponent, PSplitterAreaComponent],
    exports: [PSplitterComponent, PSplitterAreaComponent]
})
export class PSplitterModule {}
